(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sg-lots"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sg-lots')) {
  customElements.define('sg-lots', class extends HTMLElement {
    connectedCallback() {
      this.start = () => this.init();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
      else this.init();
    }
    init() {
      if (this.initialized) return;
      this.form = document.getElementById('product-form-' + this.dataset.section);
      this.scope = this.closest('product-info');
      if (!this.form || !this.scope) return;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.variants = this.config.variants;
      this.initial = this.variants.find(v => v.id === this.config.initial && v.available) || this.variants.find(v => v.available);
      if (!this.initial) return;
      this.initialized = true;
      this.count = 1;
      this.currency = new Intl.NumberFormat(this.dataset.locale || 'fr', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.cards = [...this.querySelectorAll('[data-count]')];
      this.buttons = [...this.form.querySelectorAll('[type="submit"]')];
      this.cards.forEach(card => {
        card.querySelectorAll('select').forEach(select => { select.value = this.initial.options[Number(select.dataset.option)]; });
      });
      this.onChange = event => {
        if (event.target.type === 'radio') this.count = Number(event.target.value);
        if (event.target.matches('[data-size]')) this.cards.forEach(card => { card.querySelector('[data-size]').value = event.target.value; });
        this.refresh();
      };
      this.onSubmit = event => this.submit(event);
      this.addEventListener('change', this.onChange);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.scope.classList.add('sg-lots-ready');
      this.hidden = false;
      this.refresh();
    }
    money(value) { return this.currency.format(value / 100); }
    selections(card) {
      return [...card.querySelectorAll('[data-row]')].map(row => {
        const values = [];
        const size = card.querySelector('[data-size]').value;
        values[this.config.sizeIndex] = size;
        row.querySelectorAll('select').forEach(select => {
          [...select.options].forEach(option => {
            option.disabled = !this.variants.some(v => v.available && v.options[this.config.sizeIndex] === size && v.options[Number(select.dataset.option)] === option.value);
          });
          if (select.selectedOptions[0]?.disabled) {
            const available = [...select.options].find(option => !option.disabled);
            if (available) select.value = available.value;
          }
          values[Number(select.dataset.option)] = select.value;
        });
        const variant = this.variants.find(v => v.options.every((o, i) => o === values[i]));
        row.querySelector('[data-unavailable]').hidden = Boolean(variant && variant.available);
        return variant;
      });
    }
    refresh() {
      this.cards.forEach(card => {
        const count = Number(card.dataset.count);
        const selected = count === this.count;
        card.toggleAttribute('data-selected', selected);
        card.querySelector('.sg-lots__options').hidden = !selected;
        const variants = this.selections(card);
        const groups = new Map();
        variants.filter(Boolean).forEach(v => {
          const entry = groups.get(v.id) || { variant: v, quantity: 0 };
          entry.quantity++;
          groups.set(v.id, entry);
        });
        let original = 0;
        let saving = 0;
        groups.forEach(({variant, quantity}) => {
          const line = variant.price * quantity;
          original += line;
          if (count > 1) saving += Math.floor(variant.price * Number(card.dataset.discount) / 100 + 0.000001) * quantity;
        });
        card.querySelector('[data-total]').textContent = variants.every(Boolean) ? this.money(original - saving) : '—';
        const before = card.querySelector('[data-original]');
        before.hidden = !saving;
        before.textContent = this.money(original);
        const savingLabel = card.querySelector('[data-saving]');
        savingLabel.hidden = !saving;
        savingLabel.textContent = this.config.saving.replace('[amount]', this.money(saving));
        if (selected) {
          this.selectedVariants = variants;
          this.valid = variants.every(v => v && v.available);
          this.buttons.forEach(button => { button.disabled = this.busy || this.addedWithError || !this.valid; });
        }
      });
    }
    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy || this.addedWithError) return;
      this.refresh();
      if (!this.valid) return;
      this.busy = true;
      this.refresh();
      const error = this.querySelector('[data-error]');
      error.hidden = true;
      this.buttons.forEach(b => b.setAttribute('aria-busy', 'true'));
      const groups = new Map();
      this.selectedVariants.forEach(v => groups.set(v.id, (groups.get(v.id) || 0) + 1));
      const items = [...groups].map(([id, quantity]) => ({id, quantity}));
      let added = false;
      try {
        const read = await fetch(this.dataset.cart + '.js', {headers:{'Accept':'application/json'}});
        if (!read.ok) throw new Error(this.config.error);
        const before = await read.json();
        const codes = new Set((before.discount_codes || []).filter(c => !c.code.startsWith('SGTRIO25-') || c.applicable).map(c => c.code.toUpperCase()));
        // Older Ajax responses expose applied codes on discount allocations.
        const applications = [...(before.cart_level_discount_applications || []), ...(before.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(a => a.discount_application))];
        applications.filter(a => a?.type === 'discount_code').forEach(a => codes.add(a.title.toUpperCase()));
        const size = this.selectedVariants[0].options[this.config.sizeIndex];
        const code = this.count === 3 && Number(this.dataset.discount) > 0 ? this.config.codes[this.config.productId]?.[size] : null;
        if (this.count === 3 && Number(this.dataset.discount) > 0 && !code) throw new Error(this.config.discountError);
        if (code) codes.add(code);
        if (code && codes.size > 5) throw new Error(this.config.codeLimit);
        const response = await fetch(this.dataset.cartAdd + '.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.config.error);
        added = true;
        if (code) {
          const update = await fetch(this.dataset.cart + '/update.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({discount:[...codes].join(',')})});
          const updated = await update.json();
          if (!update.ok) throw new Error(this.config.discountError);
          // Confirm actual server prices; never silently accept a smaller saving.
          const verified = items.every(item => {
            const lines = (updated.items || []).filter(line => line.variant_id === item.id);
            return lines.length && lines.every(line => line.final_line_price <= (line.original_price - Math.floor(line.original_price * 0.25 + 0.000001)) * line.quantity);
          });
          if (!verified) throw new Error(this.config.discountError);
        }
        window.location.assign(this.dataset.cart);
      } catch (e) {
        this.addedWithError = added;
        error.textContent = added ? this.config.discountError : (e.message || this.config.error);
        error.hidden = false;
        this.querySelector('[data-cart-link]').hidden = false;
      } finally {
        this.busy = false;
        this.buttons.forEach(b => b.removeAttribute('aria-busy'));
        this.refresh();
      }
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);
      if (this.onChange) this.removeEventListener('change', this.onChange);
      if (this.form && this.onSubmit) this.form.removeEventListener('submit', this.onSubmit, true);
      if (this.scope) this.scope.classList.remove('sg-lots-ready');
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
